/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */
/* eslint-disable eqeqeq */
/** @jsx jsx */
import moment from 'moment';
import React from 'react';
import { Column } from 'react-table';
import { jsx, css } from '@emotion/core';
import DataTable from 'components/organismos/DataTable/DataTable';
import FlexBox from 'components/atoms/FlexBox';
import BodyText from 'components/atoms/BodyText';
import BlockUI from 'components/molecules/BlockUi';
import { SubActionButton } from 'components/atoms/Button';
import { ActionButton } from 'components/atoms/Button/SubActionButton';
import FormContents from 'components/atoms/Form/FormContents';
import { ShiftViewDomain } from 'domain/master/attend/shiftView';
import FlexBoxItem from 'components/atoms/FlexBoxItem';
import CalendarForm from 'components/molecules/CalendarForm';
import FormTitle from 'components/atoms/Form/FormTitle';
import useShiftList from './hooks';
import OrganizationFilter from '../HopeShiftForm/OrganizationFilter';
import EmploymentFilter from '../HopeShiftForm/EmploymentFilter';
import ShiftDetailModal from './ShiftDetailModal';
import { utilityColor, textFontSize } from 'components/styles';
import FormPadding from 'components/atoms/Form/FormPadding';
import FormHeader from 'components/templates/FormHeader';
import ClickableIconButton from 'components/atoms/ClickableIconButton';
import Icon from 'components/atoms/Icon';
import CalendarMonth from 'components/molecules/CalendarV1/CalendarMonth';

function dayOfWeekAsString(dayIndex: number) {
  return ['日', '月', '火', '水', '木', '金', '土'][dayIndex];
}

const ShiftViewForm: React.FC = () => {
  const {
    selectedTimeString,
    setSelectedTimeString,
    selectedDate,
    setSelectedDate,
    detailShiftModalOpen,
    setDetailShiftModalOpen,
    shiftList,
    blocking,
    date,
    setDate,
  } = useShiftList();


  const columns: Array<Column<ShiftViewDomain>> = React.useMemo(() => [
    {
      Header: '日付',
      id: 'date',
      Cell: (cell: { row: { isExpanded: boolean, original: ShiftViewDomain } }) => (
        <BodyText customStyle={css({ display: 'flex', placeContent: 'center', color: cell.row.original.weekdayColor === 'white' ? 'black' : (cell.row.original.weekdayColor === 'rgba(255,182,193,0.25)' ? '#ED5D5D' : '#007BC3') })}>
          {`${moment(cell.row.original.targetDate).format('YYYY/MM/DD ')}(${dayOfWeekAsString(new Date(cell.row.original.targetDate).getDay())})`}
        </BodyText>
      ),
    },
    {
      Header: 'シフト確定状況',
      id: 'status',
      Cell: (cell: { row: { isExpanded: boolean, original: ShiftViewDomain } }) => {
        if (cell.row.original.fixStatus == 1) {
          return (
            <FlexBox customStyle={css({ textAlign: 'center' })}>
              <FlexBoxItem width="100%">
                <div style={{
                  backgroundColor: '#22AEE5',
                  fontSize: textFontSize.sm,
                  borderRadius: '3px',
                  padding: '5px',
                  color: utilityColor.white,
                }}
                >シフト確定済</div>
              </FlexBoxItem>
            </FlexBox>
          )
        }
        else {
          return (
            <BodyText>{""}</BodyText>
          )
        }
      },
    },
    {
      Header: '詳細',
      id: 'details',
      Cell: (cell: { row: { isExpanded: boolean, original: ShiftViewDomain } }) => {
        if (cell.row.original.dayStatus === 2 || cell.row.original.dayStatus === 3) {
          return (
            <FlexBox customStyle={css({ display: 'flex', placeContent: 'center' })}>
              <SubActionButton
                action={ActionButton.EDIT}
                text="詳細"
                onClick={() => {
                  setSelectedTimeString(`(${moment(cell.row.original.startTime).format('HH:mm')} 〜 ${moment(cell.row.original.endTime).format('HH:mm')})`);
                  setSelectedDate(new Date(cell.row.original.targetDate));
                  setDetailShiftModalOpen(true);
                }}
              />
            </FlexBox>
          );
        }

        return (<p />);
      },
    },
    {
      Header: '出勤組織',
      id: 'startTime',
      Cell: (cell: { row: { isExpanded: boolean, original: ShiftViewDomain } }) => {
        if (cell.row.original.dayStatus === 2 || cell.row.original.dayStatus === 3) {
          return (
            <BodyText customStyle={css({ paddingLeft: '6px', color: '#333333' })}>
              {cell.row.original.orgName}
            </BodyText>
          );
        }
        return (<p />);
      },
    },
    {
      Header: '勤務予定',
      id: 'endTime',
      Cell: (cell: { row: { isExpanded: boolean, original: ShiftViewDomain } }) => {
        if (cell.row.original.dayStatus === 2 || cell.row.original.workSystem === 3) {
          if (cell.row.original.holidayName) {
            return (
              <BodyText customStyle={css({ paddingLeft: '20px', color: '#333333', display: 'flex', placeContent: 'center' })}>
                {cell.row.original.holidayName}
              </BodyText>
            );
          } else {
            if (cell.row.original.startTime && cell.row.original.endTime) {
              return (
                <BodyText customStyle={css({ paddingLeft: '20px', color: '#333333', display: 'flex', placeContent: 'center' })}>
                  {`${moment(cell.row.original.startTime).format('HH:mm')}〜${moment(cell.row.original.endTime).format('HH:mm')}`}
                </BodyText>
              );
            }
          }
        } else if (cell.row.original.dayStatus === 1) {
          return (
            <BodyText customStyle={css({ paddingLeft: '20px', color: '#333333' })}>
              {cell.row.original.holidayName}
            </BodyText>
          );
        }
        return (<p />);
      },
    },
  ], [setDetailShiftModalOpen, setSelectedDate, setSelectedTimeString]);

  return (
    <React.Fragment>
      <BlockUI blocking={blocking}>
      <FormHeader title="シフト閲覧"/>
        <FormContents customStyle={css({marginTop:'60px'})}>
            <FormPadding>
            <FlexBox customStyle={css({padding:'8px 0'})}>
              <FlexBoxItem basis="100px">
                <BodyText> 営業月 </BodyText>
              </FlexBoxItem>
              <FlexBoxItem>
                <FlexBox>
                  <FlexBoxItem>
                    <CalendarMonth 
                      openActionChevron={true}
                      date={date}
                      setDate={(d: Date) => { 
                        sessionStorage.setItem('shiftView.targetDate', moment(d).format('YYYY/MM/DD'));
                        setDate(d); 
                      }}
                    />
                  </FlexBoxItem>
                  {/* <FlexBoxItem>
                    <ClickableIconButton onClick={() => {
                      setDate(new Date(moment(date).subtract(1, 'month').format('YYYY/MM/01')));
                      sessionStorage.setItem('shiftView.targetDate', moment(date).subtract(1, 'month').format('YYYY/MM/01'));
                    }} additionalCss={css({ marginLeft: '-35px' })}>
                      <Icon type="chevronLeft" color="" size="24px" />
                    </ClickableIconButton>
                  </FlexBoxItem>
                  <CalendarForm
                    required={false}
                    dateFormat="YYYY/MM"
                    label=""
                    date={date}
                    changeDate={(d: Date) => { setDate(d); }}
                  />
                  <FlexBoxItem>
                    <ClickableIconButton onClick={() => {
                      setDate(new Date(moment(date).add(1, 'month').format('YYYY/MM/01')));
                      sessionStorage.setItem('shiftView.targetDate', moment(date).add(1, 'month').format('YYYY/MM/01'));
                    }}>
                      <Icon type="chevronRight" color="" size="24px" />
                    </ClickableIconButton>
                  </FlexBoxItem> */}
                </FlexBox>
              </FlexBoxItem>
            </FlexBox>
            <OrganizationFilter
              orgCode=""
              setOrgCode={(arg: string) => {
              }}
            />
            <EmploymentFilter
              employmentId={sessionStorage.getItem('loginUser.employmentId') || ''}
              setEmploymentId={(arg: string) => {
              }}
            />
            </FormPadding>

          <div className="table-bordered table-padding"
            css={css`
              white-space: nowrap;
              overflow-x: auto;
              padding-bottom: 15px;
              table th:nth-of-type(1) {
                width: 15%;
                cursor:default;
              }
              table th:nth-child(2) {
                width: 20%;
                cursor:default;
              }
              table th:nth-of-type(3) {
                width: 10%;
                cursor:default;
              }
              table th:nth-of-type(4) {
                width: 30%;
                cursor:default;
              }
              table th:nth-of-type(5) {
                width: 25%;
                cursor:default;
              }
            `}
          >
            <DataTable
              classNameParrant="border-left-right"
              className="table-no-border-left-right" 
              columns={columns} 
              data={shiftList} 
              isGlobalFilter={false}
              minWidth="100%" 
            />
          </div>
          <div css={css('>div>div{ max-width: 600px }')}>
            <ShiftDetailModal
              time={selectedTimeString}
              targetDate={selectedDate}
              open={detailShiftModalOpen}
              openHandler={setDetailShiftModalOpen}
            />
          </div>

        </FormContents>
      </BlockUI>
    </React.Fragment>
  );
};

export default ShiftViewForm;
